import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function FacebookMessenger(props) {
    return (
        <SvgIcon {...props}>
            <path d="M161,0C72.082,0,0,67.157,0,150c0,47.205,23.412,89.311,60,116.807V324l54.818-30.273    C129.449,297.801,144.948,300,161,300c88.918,0,161-67.157,161-150S249.918,0,161,0z M177,202l-41-44l-80,44l88-94l42,44l79-44    L177,202z" />
        </SvgIcon>
    );
}

FacebookMessenger.defaultProps = {
    viewBox: '0 0 322 324'
};

export default FacebookMessenger;
